export function isFunction(value: unknown): value is Function {
  return typeof value === 'function';
}

/** @deprecated - use ?.() */
export function safeInvoke<Args extends Array<any>, R = void>(
  func: ((...args: Args) => R) | undefined,
  ...args: Args
) {
  if (isFunction(func)) {
    return func(...args);
  } else {
    return undefined;
  }
}
